<div class="loan-section">
  <div>
    <div class="top hover-pointer" (click)="toggleCollapse()">
      <div class="flex items-center gap-10">
        <h3>{{ text }}</h3>
        @if (questionText) {
          <app-tooltip [tooltipText]="questionText">
            <i class="fa-solid fa-circle-question text-cb-gold text-20"></i>
          </app-tooltip>
        }
      </div>
      <i [class.rotated]="collapsed" class="fa-solid fa-chevron-up text-cb-gold text-20"></i>
    </div>

    <div class="bar"></div>
  </div>

  @if (!collapsed) {
    <div class="content">
      <ng-content />
    </div>
  }

  @if (addText && useAdd && onAddClick && !(innerAdd && collapsed)) {
    <div class="bar-container">
      @if (!collapsed) {
        <div class="bar"></div>
      }
      <div class="add-container" (click)="onAddClick()">
        <i class="fas fa-circle-plus text-cb-gold text-20"></i>
        <p>{{ addText }}</p>
      </div>
    </div>
  }
</div>
